/**
 * ============================================================================
 * RX LENS BUILDER v2 — BudgetGlasses
 * ============================================================================
 * v2 changes:
 *   1. Rx power dropdowns (pre-populated) instead of number inputs
 *   2. "Select Lenses" gateway button
 *   3. Embedded 18-tint viewer under Fashion Tint path
 *   4. Photochromic / Transitions two-brand chooser with distinct colors
 *   5. Sleep Lens (+$39) and FL-41 (+$39) added under Fashion Tint
 *   6. Oleophobic and Anti-fog removed from Step 6
 * ============================================================================
 */

(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // 18 custom fashion tints (same data as budgetglasses.com/pages/tints)
  const FASHION_TINTS = [
    { key: 'midnight_reef', name: 'Midnight Reef', swatch: 'linear-gradient(180deg,#22497A,#A9C4E4)', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-midnight-reef.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-midnight-reef.jpg?v=1786994424' },
    { key: 'cobalt_bloom', name: 'Cobalt Bloom', swatch: '#2277EE', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-cobalt-bloom.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-cobalt-bloom.jpg?v=1786994424' },
    { key: 'coastal_mist', name: 'Coastal Mist', swatch: '#C5EAFB', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-coastal-mist.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v4-coastal-mist.jpg?v=1786995280' },
    { key: 'skyline_fade', name: 'Skyline Fade', swatch: 'linear-gradient(180deg,#3F87F2,#E4EEFF)', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-skyline-fade.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-skyline-fade.jpg?v=1786994424' },
    { key: 'sea_glass', name: 'Sea Glass', swatch: '#8CC9BC', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-sea-glass.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-sea-glass.jpg?v=1786994424' },
    { key: 'dawn_bay', name: 'Dawn Bay', swatch: 'linear-gradient(180deg,#3B8FDC,#E4EA74)', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-dawn-bay.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-dawn-bay.jpg?v=1786994424' },
    { key: 'mojito', name: 'Mojito', swatch: '#B6F5C6', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-mojito.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-mojito.jpg?v=1786994424' },
    { key: 'meadow', name: 'Meadow', swatch: '#9CB955', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-meadow.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-meadow.jpg?v=1786994424' },
    { key: 'pinewood', name: 'Pinewood', swatch: '#354236', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-pinewood.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-pinewood.jpg?v=1786994424' },
    { key: 'solar_flare', name: 'Solar Flare', swatch: '#F5D400', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-solar-flare.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-solar-flare.jpg?v=1786994424' },
    { key: 'buttercream', name: 'Buttercream', swatch: '#FCF3D2', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-buttercream.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v4-buttercream.jpg?v=1786995280' },
    { key: 'whiskey', name: 'Whiskey', swatch: '#8A6E1A', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-whiskey.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-whiskey.jpg?v=1786994424' },
    { key: 'sunset_highway', name: 'Sunset Highway', swatch: '#F58028', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-sunset-highway.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-sunset-highway.jpg?v=1786994424' },
    { key: 'merlot', name: 'Merlot', swatch: '#A34635', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-merlot.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-merlot.jpg?v=1786994424' },
    { key: 'rose_petal_fade', name: 'Rose Petal Fade', swatch: 'linear-gradient(180deg,#B23561,#F6E1E6)', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-rose-petal-fade.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-rose-petal-fade.jpg?v=1786994424' },
    { key: 'orchid_mist', name: 'Orchid Mist', swatch: '#EADEFC', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-orchid-mist.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-orchid-mist.jpg?v=1786994424' },
    { key: 'storm_grey_fade', name: 'Storm Grey Fade', swatch: 'linear-gradient(180deg,#A6A6A6,#F0F0F0)', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-storm-grey-fade.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-storm-grey-fade.jpg?v=1786994424' },
    { key: 'charcoal_fade', name: 'Charcoal Fade', swatch: 'linear-gradient(180deg,#2A2A2A,#BCBCBC)', female: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/ocurx-tint-charcoal-fade.jpg?v=1786943212', male: 'https://cdn.shopify.com/s/files/1/0811/9110/8820/files/bg-tint-male-v3-charcoal-fade.jpg?v=1786994424' }
  ];

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const builder = $('[data-rx-builder]');
    const gateway = $('[data-rx-gateway]');
    if (!builder || !gateway) return;

    const productPrice = parseFloat(builder.dataset.productPrice) || 0;

    const state = {
      currentStep: 1,
      totalSteps: 7,
      productPrice: productPrice,
      selections: {},
      tintGender: 'female'
    };

    // ==========================================================================
    // GATEWAY — hide native/SB add-to-cart, show "Select Lenses" button
    // ==========================================================================

    // Relocate the gateway node right under the product price on the page.
    // Falls back to keeping it in place if no price element can be found.
    // Preferred: place the gateway directly below the Virtual Try On (Camweara) button
    // so it sits in the same 490px-wide product-info wrapper and matches its width.
    // Fallback: insert as a sibling after the price container.
    function relocateGatewayToPrice() {
      if (gateway.dataset.rxRelocated === 'true') return;

      // 1) Preferred anchor: Virtual Try On block (Camweara)
      const vtoBtn = document.getElementById('camweara-tryon-button');
      const vtoBlock = vtoBtn ? vtoBtn.closest('.shopify-block, .shopify-app-block, .not-in-quickbuy') : null;
      if (vtoBlock && vtoBlock.offsetParent !== null) {
        vtoBlock.parentNode.insertBefore(gateway, vtoBlock.nextSibling);
        gateway.dataset.rxRelocated = 'true';
        return;
      }

      // 2) Fallback: place next to price
      const priceSelectors = [
        '.price-container', '.product__price', '.product-price', '.price__container',
        '.price-wrapper', '[data-product-price]', '.product__info .price', '.price',
        'product-price', '.product-single__price', '[class*="ProductPrice"]'
      ];
      let priceEl = null;
      for (const sel of priceSelectors) {
        const el = document.querySelector(sel);
        if (el && el.offsetParent !== null) { priceEl = el; break; }
      }
      if (!priceEl) return;
      const anchor = priceEl.closest('.price-container, .price, .product__price, .product-price, .price__container') || priceEl;
      anchor.parentNode.insertBefore(gateway, anchor.nextSibling);
      gateway.dataset.rxRelocated = 'true';
    }

    function hideThemeCartControls() {
      // Hide the theme's native Add to Cart form buttons
      const cartForms = $$('form[action*="/cart/add"]');
      cartForms.forEach((form) => {
        const btn = form.querySelector('[name="add"], button[type="submit"]');
        if (btn && !btn.closest('[data-rx-builder]')) {
          btn.setAttribute('data-rx-hidden-original', 'true');
          btn.style.display = 'none';
        }
      });

      // Hide the SB Prescription Lens app's "Select Lenses" button if present.
      // The SB app injects buttons commonly labeled "Select Lenses" / "Select Lens"
      // — hide by common selectors and by text match.
      const potentialSb = [
        '.sb-prescription-lens', '.sb-lens-btn', '.setu-lens-btn',
        '[data-setu-lens]', '[class*="sunbow"]', '[class*="setubridge"]',
        'button:has-text("Select Lenses")'
      ];
      potentialSb.forEach((sel) => {
        try {
          $$(sel).forEach((el) => {
            el.setAttribute('data-rx-hidden-sb', 'true');
            el.style.display = 'none';
          });
        } catch (e) { /* invalid selector, ignore */ }
      });

      // Text-based fallback for SB button
      $$('button, a').forEach((el) => {
        const t = (el.textContent || '').trim().toLowerCase();
        if ((t === 'select lenses' || t === 'select lens') && !el.closest('[data-rx-gateway]') && !el.closest('[data-rx-builder]')) {
          el.setAttribute('data-rx-hidden-sb', 'true');
          el.style.display = 'none';
        }
      });
    }

    $('[data-rx-gateway-btn]', gateway).addEventListener('click', () => {
      gateway.setAttribute('hidden', '');
      builder.removeAttribute('hidden');
      window.scrollTo({ top: builder.offsetTop - 20, behavior: 'smooth' });
    });

    hideThemeCartControls();
    relocateGatewayToPrice();
    // Re-run in case theme scripts inject the button later
    setTimeout(() => { hideThemeCartControls(); relocateGatewayToPrice(); }, 500);
    setTimeout(() => { hideThemeCartControls(); relocateGatewayToPrice(); }, 1500);
    setTimeout(() => { hideThemeCartControls(); relocateGatewayToPrice(); }, 3000);

    // ==========================================================================
    // POWER DROPDOWNS — build Rx grid with pre-populated selects
    // ==========================================================================

    function range(start, end, step) {
      const out = [];
      for (let v = start; v <= end + 0.0001; v += step) {
        out.push(parseFloat(v.toFixed(2)));
      }
      return out;
    }

    function fmtSigned(n) {
      if (n === 0) return '0.00';
      const s = n > 0 ? '+' : '';
      return s + n.toFixed(2);
    }

    function buildOptions(values, formatter, includeEmpty = true) {
      let html = includeEmpty ? '<option value="">--</option>' : '';
      values.forEach((v) => {
        html += `<option value="${v.toFixed(2)}">${formatter(v)}</option>`;
      });
      return html;
    }

    function buildRxGrid() {
      const wrap = $('[data-rx-grid-wrap]', builder);
      if (!wrap) return;

      const sphValues = range(-10, 10, 0.25);
      const cylValues = range(-6, 6, 0.25);
      const axisValues = Array.from({ length: 180 }, (_, i) => i + 1);
      const addValues = range(0.75, 3.5, 0.25);

      const sphOpts = buildOptions(sphValues, fmtSigned);
      const cylOpts = buildOptions(cylValues, fmtSigned);
      const axisOpts = '<option value="">--</option>' + axisValues.map((v) => `<option value="${v}">${v}</option>`).join('');
      const addOpts = buildOptions(addValues, fmtSigned);

      wrap.innerHTML = `
        <table class="rx-grid">
          <thead>
            <tr>
              <th></th>
              <th>OD (Right)</th>
              <th>OS (Left)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Sphere (SPH)</th>
              <td><select name="rx_sph_od" data-rx-input>${sphOpts}</select></td>
              <td><select name="rx_sph_os" data-rx-input>${sphOpts}</select></td>
            </tr>
            <tr>
              <th>Cylinder (CYL)</th>
              <td><select name="rx_cyl_od" data-rx-input>${cylOpts}</select></td>
              <td><select name="rx_cyl_os" data-rx-input>${cylOpts}</select></td>
            </tr>
            <tr>
              <th>Axis</th>
              <td><select name="rx_axis_od" data-rx-input>${axisOpts}</select></td>
              <td><select name="rx_axis_os" data-rx-input>${axisOpts}</select></td>
            </tr>
            <tr data-rx-add-row hidden>
              <th>ADD</th>
              <td><select name="rx_add_od" data-rx-input>${addOpts}</select></td>
              <td><select name="rx_add_os" data-rx-input>${addOpts}</select></td>
            </tr>
          </tbody>
        </table>
      `;
    }

    function buildPrismGrid() {
      const wrap = $('[data-rx-prism-wrap]', builder);
      if (!wrap) return;

      const prismValues = range(0, 5, 0.25);
      const prismOpts = buildOptions(prismValues, (v) => v.toFixed(2));
      const baseOpts = '<option value="">--</option><option value="Up">Up</option><option value="Down">Down</option><option value="In">In</option><option value="Out">Out</option>';

      wrap.innerHTML = `
        <table class="rx-grid">
          <tbody>
            <tr>
              <th>Prism</th>
              <td><select name="rx_prism_od" data-rx-input>${prismOpts}</select></td>
              <td><select name="rx_prism_os" data-rx-input>${prismOpts}</select></td>
            </tr>
            <tr>
              <th>Base</th>
              <td><select name="rx_base_od" data-rx-input>${baseOpts}</select></td>
              <td><select name="rx_base_os" data-rx-input>${baseOpts}</select></td>
            </tr>
          </tbody>
        </table>
      `;
    }

    function populatePDDropdowns() {
      // Single PD: 50–75 in 0.5 steps
      const singleVals = range(50, 75, 0.5);
      const singleOpts = singleVals.map((v) => `<option value="${v}">${v}</option>`).join('');
      $$('[data-rx-dropdown="pd_single"]', builder).forEach((sel) => {
        sel.innerHTML = '<option value="">-- Select --</option>' + singleOpts;
      });

      // Dual PD half: 25–37 in 0.5 steps
      const halfVals = range(25, 37, 0.5);
      const halfOpts = halfVals.map((v) => `<option value="${v}">${v}</option>`).join('');
      $$('[data-rx-dropdown="pd_half"]', builder).forEach((sel) => {
        const placeholder = sel.name === 'rx_pd_od' ? 'OD' : 'OS';
        sel.innerHTML = `<option value="">${placeholder}</option>` + halfOpts;
      });
    }

    // ==========================================================================
    // TINT VIEWER — 18 swatches with live model preview
    // ==========================================================================

    function buildTintViewer() {
      const wrap = $('[data-rx-tint-swatches]', builder);
      if (!wrap) return;

      wrap.innerHTML = FASHION_TINTS.map((tint) => `
        <label class="rx-tint-swatch" data-rx-tint-key="${tint.key}">
          <input type="radio" name="rx_fashion_tint" value="${tint.key}" data-rx-input data-price="0">
          <span class="rx-tint-swatch__chip" style="background:${tint.swatch}"></span>
          <span class="rx-tint-swatch__name">${tint.name}</span>
        </label>
      `).join('');

      // Wire swatch clicks to update preview
      $$('[data-rx-tint-key]', wrap).forEach((el) => {
        el.addEventListener('click', () => {
          const key = el.dataset.rxTintKey;
          const tint = FASHION_TINTS.find((t) => t.key === key);
          if (!tint) return;
          updateTintPreview(tint);
        });
      });

    }

    function updateTintPreview(tint, updateName = true) {
      const modelImg = $('[data-rx-tint-model="female"]', builder);
      const nameEl = $('[data-rx-tint-name]', builder);
      if (modelImg) modelImg.src = tint.female;
      if (nameEl && updateName) nameEl.textContent = tint.name;
    }

    // ==========================================================================
    // STEP VISIBILITY
    // ==========================================================================

    function showStep(n) {
      $$('[data-rx-step]', builder).forEach((el) => {
        const step = parseInt(el.dataset.rxStep, 10);
        if (step === n) {
          el.removeAttribute('hidden');
          el.setAttribute('data-rx-step-active', '');
        } else {
          el.setAttribute('hidden', '');
          el.removeAttribute('data-rx-step-active');
        }
      });
      state.currentStep = n;
      updateProgress();
      updateNavButtons();
      window.scrollTo({ top: builder.offsetTop - 20, behavior: 'smooth' });
    }

    function updateProgress() {
      const totalVisible = computeVisibleSteps().length;
      const currentIndex = computeVisibleSteps().indexOf(state.currentStep) + 1;
      $('[data-rx-progress-current]', builder).textContent = currentIndex;
      $('[data-rx-progress-total]', builder).textContent = totalVisible;
    }

    function computeVisibleSteps() {
      const usage = state.selections.rx_usage;
      const lensType = state.selections.rx_lens_type;
      if (usage === 'frame_only') return [1, 7];
      if (usage === 'blue_light_zero') return [1, 4, 5, 6, 7];
      if (usage === 'readers') return [1, 3, 4, 5, 6, 7];
      if (lensType === 'frame_only_alt') return [1, 2, 5, 6, 7];
      return [1, 2, 3, 4, 5, 6, 7];
    }

    function nextStep() {
      const visible = computeVisibleSteps();
      const idx = visible.indexOf(state.currentStep);
      if (idx === -1 || idx === visible.length - 1) return;
      showStep(visible[idx + 1]);
    }

    function prevStep() {
      const visible = computeVisibleSteps();
      const idx = visible.indexOf(state.currentStep);
      if (idx <= 0) return;
      showStep(visible[idx - 1]);
    }

    function updateNavButtons() {
      const visible = computeVisibleSteps();
      const idx = visible.indexOf(state.currentStep);
      const isFirst = idx === 0;
      const isLast = idx === visible.length - 1;
      $('[data-rx-back]', builder).toggleAttribute('hidden', isFirst);
      $('[data-rx-next]', builder).toggleAttribute('hidden', isLast);
      $('[data-rx-add-to-cart]', builder).toggleAttribute('hidden', !isLast);
    }

    // ==========================================================================
    // STATE UPDATES + MUTUAL EXCLUSIVITY
    // ==========================================================================

    function handleInputChange(e) {
      const el = e.target;
      const name = el.name;
      if (!name) return;

      if (el.type === 'checkbox') {
        if (el.checked) state.selections[name] = el.value;
        else delete state.selections[name];
      } else if (el.type === 'file') {
        state.selections[name] = el.files[0] ? el.files[0].name : null;
      } else {
        state.selections[name] = el.value;
      }

      onFieldChanged(name);
      updatePrice();
      renderReview();
      maybeAutoAdvance(name, el);
    }

    // Auto-advance: when a customer picks a single-choice radio that completes
    // the current step, jump to the next step after a short delay so they see
    // the highlight before the modal moves on.
    //
    // Fields excluded: rx_finish (has a sub-panel that opens on the same step),
    // rx_fashion_kind, rx_pc_brand, rx_transitions_type, rx_photochromic_color,
    // rx_transitions_color, rx_fashion_tint, rx_sun_tint, rx_polarized (all
    // sub-choices within the finish step). Manual Rx entry never auto-advances
    // (needs multiple fields). Upload/email entry never auto-advances.
    const AUTO_ADVANCE_FIELDS = new Set([
      'rx_usage',
      'rx_lens_type',
      'rx_entry_method',
      'rx_material',
      'rx_ar'
    ]);

    function maybeAutoAdvance(name, el) {
      if (el.type !== 'radio') return;
      if (!AUTO_ADVANCE_FIELDS.has(name)) return;
      // Only advance if this selection is valid for the current step
      if (!validateCurrentStep(true)) return;
      window.setTimeout(() => {
        // Confirm we're still on the same step (guard against races)
        if (typeof nextStep === 'function') nextStep();
      }, 400);
    }

    function onFieldChanged(name) {
      if (name === 'rx_usage') {
        clearSelectionsFrom(['rx_lens_type', 'rx_entry_method', 'rx_finish', 'rx_ar', 'rx_fashion_kind', 'rx_fashion_tint', 'rx_sun_tint', 'rx_polarized', 'rx_pc_brand', 'rx_photochromic_color', 'rx_transitions_color', 'rx_transitions_type', 'rx_therapeutic_kind']);
        if (state.selections.rx_usage === 'readers') {
          state.selections.rx_lens_type = 'sv_reading';
        }
        updateProgress();
      }

      if (name === 'rx_lens_type') {
        const needsAdd = ['progressive', 'bifocal'].includes(state.selections.rx_lens_type);
        const addRow = $('[data-rx-add-row]', builder);
        if (addRow) addRow.toggleAttribute('hidden', !needsAdd);
        $$('[name="rx_add_od"], [name="rx_add_os"]', builder).forEach((input) => {
          input.required = needsAdd;
        });
        updateProgress();
      }

      if (name === 'rx_pd_mode') {
        const single = $('[data-rx-pd-single]', builder);
        const dual = $('[data-rx-pd-dual]', builder);
        if (state.selections.rx_pd_mode === 'dual') {
          single.setAttribute('hidden', '');
          dual.removeAttribute('hidden');
        } else {
          single.removeAttribute('hidden');
          dual.setAttribute('hidden', '');
        }
      }

      if (['rx_sph_od', 'rx_sph_os'].includes(name)) {
        applyRxRecommendations();
      }

      if (name === 'rx_finish') {
        renderFinishSubpanel();
        const finish = state.selections.rx_finish;
        if (finish !== 'finish_fashion_tint') {
          delete state.selections.rx_fashion_kind;
          delete state.selections.rx_fashion_tint;
        }
        if (finish !== 'finish_sun_tint') {
          delete state.selections.rx_sun_tint;
          delete state.selections.rx_polarized;
        }
        if (finish !== 'finish_photochromic') {
          delete state.selections.rx_pc_brand;
          delete state.selections.rx_photochromic_color;
          delete state.selections.rx_transitions_color;
          delete state.selections.rx_transitions_type;
        }
        if (finish !== 'finish_therapeutic') {
          delete state.selections.rx_therapeutic_kind;
        }
        if (finish !== 'finish_clear') delete state.selections.rx_ar;
      }

      // Photochromic brand changed — show correct color sub-panel
      if (name === 'rx_pc_brand') {
        const brand = state.selections.rx_pc_brand;
        $$('[data-rx-pc-colors]', builder).forEach((el) => {
          el.toggleAttribute('hidden', el.dataset.rxPcColors !== brand);
        });
        // Clear the other brand's color/type selections
        if (brand === 'photochromic') {
          delete state.selections.rx_transitions_color;
          delete state.selections.rx_transitions_type;
        }
        if (brand === 'transitions') {
          delete state.selections.rx_photochromic_color;
          // Default Transitions type to Regular if not set
          if (!state.selections.rx_transitions_type) {
            state.selections.rx_transitions_type = 'regular';
            const regInput = $('[name="rx_transitions_type"][value="regular"]', builder);
            if (regInput) regInput.checked = true;
          }
        }
      }

      if (name === 'rx_entry_method') {
        const manualConfirm = $('[data-rx-confirm-manual]', builder);
        if (manualConfirm) manualConfirm.toggleAttribute('hidden', state.selections.rx_entry_method !== 'manual');
      }
    }

    function clearSelectionsFrom(names) {
      names.forEach((n) => delete state.selections[n]);
      names.forEach((n) => {
        $$(`[name="${n}"]`, builder).forEach((input) => {
          if (input.type === 'radio' || input.type === 'checkbox') input.checked = false;
          else if (input.tagName === 'SELECT') input.value = '';
        });
      });
    }

    // ==========================================================================
    // TABS
    // ==========================================================================

    function initTabs() {
      $$('[data-rx-tab]', builder).forEach((tab) => {
        tab.addEventListener('click', () => {
          const method = tab.dataset.rxTab;
          $$('[data-rx-tab]', builder).forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
          $$('[data-rx-pane]', builder).forEach((pane) => {
            pane.toggleAttribute('hidden', pane.dataset.rxPane !== method);
          });
          state.selections.rx_entry_method = method;
          onFieldChanged('rx_entry_method');
          renderReview();
        });
      });
    }

    // ==========================================================================
    // FINISH SUB-PANELS
    // ==========================================================================

    function renderFinishSubpanel() {
      const finish = state.selections.rx_finish;
      const map = {
        finish_clear: 'ar',
        finish_fashion_tint: 'fashion_tint',
        finish_sun_tint: 'sun_tint',
        finish_therapeutic: 'therapeutic',
        finish_photochromic: 'photochromic'
      };
      const target = map[finish];
      $$('[data-rx-substep]', builder).forEach((el) => {
        el.toggleAttribute('hidden', el.dataset.rxSubstep !== target);
      });
      // Fashion tint has been simplified: it's always the 18-color picker. No sub-choice.
      // Legacy rx_fashion_kind is no longer set here — always treated as 'fashion_color'.
      if (finish === 'finish_fashion_tint') {
        state.selections.rx_fashion_kind = 'fashion_color';
      } else {
        delete state.selections.rx_fashion_kind;
      }
      // Auto-scroll the newly-opened sub-panel into view (esp. helpful on mobile
      // where the sub-panel appears far below the finish tiles).
      if (target) {
        const openPanel = $(`[data-rx-substep="${target}"]`, builder);
        if (openPanel) {
          setTimeout(() => {
            openPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    }

    // ==========================================================================
    // MATERIAL RECOMMENDATIONS
    // ==========================================================================

    function applyRxRecommendations() {
      const sphOd = Math.abs(parseFloat(state.selections.rx_sph_od) || 0);
      const sphOs = Math.abs(parseFloat(state.selections.rx_sph_os) || 0);
      const maxSph = Math.max(sphOd, sphOs);

      const hi167Badge = $('[data-rx-recommend="hi167"]', builder);
      const hi174Badge = $('[data-rx-recommend="hi174"]', builder);

      if (hi167Badge) hi167Badge.toggleAttribute('hidden', !(maxSph > 4.0));
      if (hi174Badge) hi174Badge.toggleAttribute('hidden', !(maxSph > 6.0));

      const cr39 = $('[data-rx-material="mat_cr39"]', builder);
      const poly = $('[data-rx-material="mat_poly"]', builder);
      if (cr39) cr39.toggleAttribute('hidden', maxSph > 8.0);
      if (poly) poly.toggleAttribute('hidden', maxSph > 8.0);
    }

    // ==========================================================================
    // PRICING
    // ==========================================================================

    function updatePrice() {
      let total = state.productPrice;
      $$('[data-rx-input]', builder).forEach((el) => {
        if (!el.hasAttribute('data-price')) return;
        const price = parseFloat(el.dataset.price) || 0;
        if (el.type === 'checkbox' && el.checked) total += price;
        else if (el.type === 'radio' && el.checked) total += price;
      });
      if (total < 0) total = 0;
      const el = $('[data-rx-total]', builder);
      if (el) el.textContent = '$' + total.toFixed(2);
    }

    // ==========================================================================
    // REVIEW
    // ==========================================================================

    function renderReview() {
      const wrap = $('[data-rx-review]', builder);
      if (!wrap) return;
      const s = state.selections;
      const rows = [];

      const labels = {
        rx_usage: 'Usage',
        rx_lens_type: 'Lens type',
        rx_entry_method: 'Rx entry',
        rx_material: 'Material',
        rx_finish: 'Finish',
        rx_fashion_tint: 'Tint color',
        rx_therapeutic_kind: 'Therapeutic lens',
        rx_sun_tint: 'Sun tint',
        rx_polarized: 'Polarized',
        rx_pc_brand: 'Brand',
        rx_photochromic_color: 'Photochromic color',
        rx_transitions_type: 'Transitions type',
        rx_transitions_color: 'Transitions color',
        rx_ar: 'Anti-Reflective coating'
      };

      Object.keys(labels).forEach((key) => {
        if (s[key]) rows.push([labels[key], humanize(s[key])]);
      });

      if (s.rx_entry_method === 'manual') {
        const rxSummary = ['OD', 'OS'].map((eye) => {
          const suffix = eye === 'OD' ? '_od' : '_os';
          const sph = s['rx_sph' + suffix] || '—';
          const cyl = s['rx_cyl' + suffix] || '—';
          const axis = s['rx_axis' + suffix] || '—';
          const add = s['rx_add' + suffix] || '';
          return `${eye}: SPH ${sph} · CYL ${cyl} · AXIS ${axis}${add ? ' · ADD ' + add : ''}`;
        }).join('<br>');
        rows.push(['Prescription', rxSummary]);

        const pd = s.rx_pd_mode === 'dual'
          ? `Dual: OD ${s.rx_pd_od || '—'} / OS ${s.rx_pd_os || '—'} mm`
          : `${s.rx_pd_single || '—'} mm`;
        rows.push(['PD', pd]);
      } else if (s.rx_entry_method === 'upload') {
        rows.push(['Rx file', s.rx_prescription_file || 'Not uploaded']);
      } else if (s.rx_entry_method === 'email') {
        rows.push(['Doctor', `${s.rx_doctor_name || ''} · ${s.rx_doctor_phone || ''}`]);
      }

      const coatings = ['UV400', 'Scratch-resistant'];
      if (s.rx_coating_bluelight) coatings.push('Blue light filter');
      rows.push(['Coatings', coatings.join(', ')]);

      wrap.innerHTML = rows.map(
        ([k, v]) => `<div class="rx-review__row"><span class="rx-review__key">${k}</span><span class="rx-review__val">${v}</span></div>`
      ).join('');
    }

    function humanize(str) {
      // Null-safe: return empty string for undefined/null/empty inputs so that
      // .replace() never fires on an undefined value. Prevents cart-add crash.
      if (str === undefined || str === null || str === '') return '';
      const map = {
        rx_clear: 'Prescription glasses',
        rx_tinted: 'Prescription sunglasses',
        readers: 'Reading glasses',
        blue_light_zero: 'Blue light only',
        frame_only: 'Frame only',
        frame_only_alt: 'Frame only (no lenses)',
        sv_distance: 'Single vision - Distance',
        sv_reading: 'Single vision - Reading',
        progressive: 'Progressive',
        bifocal: 'Bifocal',
        manual: 'Entered manually',
        upload: 'Uploaded file',
        email: "Doctor's office",
        mat_cr39: 'CR-39 (1.50)',
        mat_poly: 'Polycarbonate (1.59)',
        mat_hi167: 'High-index 1.67',
        mat_hi174: 'High-index 1.74',
        finish_clear: 'Clear',
        finish_fashion_tint: 'Fashion tint',
        finish_sun_tint: 'Sun tint',
        finish_photochromic: 'Photochromic / Transitions',
        fashion_color: 'Fashion color',
        sleep_lens: 'Sleep Lens',
        fl41: 'FL-41 (Headache/Migraine)',
        finish_therapeutic: 'Therapeutic lenses',
        photochromic: 'Photochromic',
        transitions: 'Transitions®',
        regular: 'Signature',
        xtractive: 'XTRActive',
        ar_none: 'None',
        ar_standard: 'Standard Anti-Reflective',
        ar_premium: 'Premium Anti-Reflective',
        polarized: 'Yes'
      };
      // Fashion tint keys — humanize by looking them up
      const tint = FASHION_TINTS.find((t) => t.key === str);
      if (tint) return tint.name;
      if (typeof str !== 'string') return '';
      return map[str] || str.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    }

    // ==========================================================================
    // VALIDATION
    // ==========================================================================

    function validateCurrentStep(silent) {
      const _fail = silent ? (() => false) : fail;
      if (state.currentStep === 1) {
        if (!state.selections.rx_usage) return _fail('Please choose a usage type.');
      }
      if (state.currentStep === 2) {
        if (!state.selections.rx_lens_type) return _fail('Please choose a lens type.');
      }
      if (state.currentStep === 3) {
        const method = state.selections.rx_entry_method || 'manual';
        if (method === 'manual') {
          if (!state.selections.rx_sph_od) return _fail('Please select SPH for OD.');
          if (!state.selections.rx_sph_os) return _fail('Please select SPH for OS.');
          if (['progressive', 'bifocal'].includes(state.selections.rx_lens_type)) {
            if (!state.selections.rx_add_od || !state.selections.rx_add_os) return _fail('ADD value required for progressive/bifocal.');
          }
        } else if (method === 'upload') {
          if (!state.selections.rx_prescription_file) return _fail('Please upload your prescription file.');
        } else if (method === 'email') {
          if (!state.selections.rx_doctor_name || !state.selections.rx_doctor_phone) return _fail("Please provide your doctor's contact info.");
        }
      }
      if (state.currentStep === 4) {
        if (!state.selections.rx_material) return _fail('Please choose a lens material.');
      }
      if (state.currentStep === 5) {
        if (!state.selections.rx_finish) return _fail('Please choose a lens finish.');
        const finish = state.selections.rx_finish;
        if (finish === 'finish_fashion_tint') {
          if (!state.selections.rx_fashion_tint) return _fail('Please pick a tint color.');
        }
        if (finish === 'finish_therapeutic') {
          if (!state.selections.rx_therapeutic_kind) return _fail('Please choose Sleep Lens or FL-41.');
        }
        if (finish === 'finish_sun_tint' && !state.selections.rx_sun_tint) return _fail('Please pick a sun tint.');
        if (finish === 'finish_photochromic') {
          if (!state.selections.rx_pc_brand) return _fail('Please choose Photochromic or Transitions.');
          if (state.selections.rx_pc_brand === 'photochromic' && !state.selections.rx_photochromic_color) return _fail('Please pick a Photochromic color.');
          if (state.selections.rx_pc_brand === 'transitions' && !state.selections.rx_transitions_color) return _fail('Please pick a Transitions color.');
        }
        if (finish === 'finish_clear' && !state.selections.rx_ar) return _fail('Please choose an AR option.');
      }
      return true;
    }

    function validateMutualExclusivity() {
      const s = state.selections;
      const hasFashion = s.rx_finish === 'finish_fashion_tint';
      const hasSun = s.rx_finish === 'finish_sun_tint';
      const hasTherapeutic = s.rx_finish === 'finish_therapeutic';
      if ((hasFashion || hasSun || hasTherapeutic) && s.rx_ar && s.rx_ar !== 'ar_none') {
        return fail('Specialty tints and Anti-Reflective coating cannot be combined.');
      }
      if (hasFashion && (s.rx_pc_brand || s.rx_photochromic_color || s.rx_transitions_color || s.rx_transitions_type)) {
        return fail('Fashion tints cannot be combined with photochromic/Transitions.');
      }
      if (hasFashion && s.rx_polarized) {
        return fail('Fashion tints cannot be polarized.');
      }
      if (s.rx_polarized && !hasSun) {
        return fail('Polarized is only available with sun tints.');
      }
      return true;
    }

    function fail(msg) {
      alert(msg);
      return false;
    }

    // ==========================================================================
    // CART INTEGRATION
    // ==========================================================================

    function getProductForm() {
      // Prefer a visible form (some themes render both desktop + mobile variants).
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      const visible = forms.find((f) => f.offsetParent !== null);
      return visible || forms[0] || null;
    }

    function injectLineItemProperties() {
      const form = getProductForm();
      if (!form) return false;
      form.querySelectorAll('[data-rx-injected]').forEach((el) => el.remove());

      const props = buildLineItemProperties();
      Object.entries(props).forEach(([key, val]) => {
        if (val === undefined || val === null || val === '') return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = val;
        input.dataset.rxInjected = 'true';
        form.appendChild(input);
      });

      const fileInput = builder.querySelector('input[type="file"][name="rx_prescription_file"]');
      if (fileInput && fileInput.files.length > 0) {
        fileInput.name = 'properties[Rx File]';
        fileInput.dataset.rxInjected = 'true';
        form.appendChild(fileInput);
      }
      return true;
    }

    function buildLineItemProperties() {
      const s = state.selections;
      // Default entry method to 'manual' if not explicitly set (some flows never set it)
      const entryMethod = s.rx_entry_method || 'manual';
      const props = {
        'Usage': humanize(s.rx_usage),
        'Lens Type': humanize(s.rx_lens_type),
        'Rx Entry': humanize(entryMethod),
        'Material': humanize(s.rx_material),
        'Finish': humanize(s.rx_finish)
      };

      if (entryMethod === 'manual') {
        const rxLines = [];
        ['od', 'os'].forEach((eye) => {
          const label = eye.toUpperCase();
          const sph = s['rx_sph_' + eye] || '';
          const cyl = s['rx_cyl_' + eye] || '';
          const axis = s['rx_axis_' + eye] || '';
          const add = s['rx_add_' + eye] || '';
          const prism = s['rx_prism_' + eye] || '';
          const base = s['rx_base_' + eye] || '';
          rxLines.push(
            `${label}: SPH ${sph || '-'} CYL ${cyl || '-'} AXIS ${axis || '-'}${add ? ' ADD ' + add : ''}${prism ? ' PRISM ' + prism + ' ' + base : ''}`
          );
        });
        props['Prescription'] = rxLines.join(' | ');
        props['PD'] = s.rx_pd_mode === 'dual'
          ? `OD ${s.rx_pd_od || '-'} / OS ${s.rx_pd_os || '-'} mm`
          : `${s.rx_pd_single || '63'} mm`;
      } else if (entryMethod === 'email') {
        props['Doctor Name'] = s.rx_doctor_name;
        props['Doctor Phone'] = s.rx_doctor_phone;
        props['Patient Name'] = s.rx_patient_name;
        props['Exam Date'] = s.rx_exam_date;
      }

      if (s.rx_fashion_tint) props['Fashion Tint'] = humanize(s.rx_fashion_tint);
      if (s.rx_therapeutic_kind) props['Therapeutic Lens'] = humanize(s.rx_therapeutic_kind);
      if (s.rx_sun_tint) props['Sun Tint'] = humanize(s.rx_sun_tint);
      if (s.rx_polarized) props['Polarized'] = 'Yes';
      if (s.rx_pc_brand) props['PC Brand'] = humanize(s.rx_pc_brand);
      if (s.rx_photochromic_color) props['Photochromic Color'] = humanize(s.rx_photochromic_color);
      if (s.rx_transitions_type) props['Transitions Type'] = humanize(s.rx_transitions_type);
      if (s.rx_transitions_color) props['Transitions Color'] = humanize(s.rx_transitions_color);
      if (s.rx_ar) props['Anti-Reflective Coating'] = humanize(s.rx_ar);

      const coatings = ['UV400', 'Scratch-resistant'];
      if (s.rx_coating_bluelight) coatings.push('Blue light filter');
      props['Coatings'] = coatings.join(', ');

      let finishTag = '';
      if (s.rx_finish === 'finish_clear') finishTag = 'ar-clear';
      else if (s.rx_finish === 'finish_fashion_tint') finishTag = 'fashion-tint';
      else if (s.rx_finish === 'finish_therapeutic') {
        if (s.rx_therapeutic_kind === 'sleep_lens') finishTag = 'sleep-lens';
        else if (s.rx_therapeutic_kind === 'fl41') finishTag = 'fl41';
        else finishTag = 'therapeutic';
      }
      else if (s.rx_finish === 'finish_sun_tint') finishTag = s.rx_polarized ? 'sun-tint-polarized' : 'sun-tint';
      else if (s.rx_finish === 'finish_photochromic') {
        if (s.rx_pc_brand === 'transitions') {
          finishTag = s.rx_transitions_type === 'xtractive' ? 'transitions-xtractive' : 'transitions';
        } else {
          finishTag = 'photochromic';
        }
      }
      if (finishTag) props['_FinishTag'] = finishTag;

      return props;
    }

    // ==========================================================================
    // UPGRADE VARIANT MAP
    // Each entry maps a selection condition to the Rx Lens Upgrade parent
    // product's variant ID. Prices in Shopify must match the p_* Liquid vars.
    // Product GID: gid://shopify/Product/9317694472404
    // ==========================================================================

    // Live variant prices in cents — injected by Liquid from the Rx Lens Upgrade product.
    // Falls back to empty object; getUpgradeVariantIds() then skips $0-guarded lines safely.
    const VARIANT_PRICES = (window.__RX_VARIANT_PRICES__) || {};
    function getVariantPriceCents(variantId) {
      const p = VARIANT_PRICES[variantId];
      return (typeof p === 'number' && p > 0) ? p : 0;
    }

    const UPGRADE_VARIANTS = {
      // Material upgrades (poly / hi167 / hi174) — CR-39 is free/base
      MAT_POLY:        48513353613524,
      MAT_HI167:       48513353646292,
      MAT_HI174:       48513353679060,
      // AR coating upgrades — 'ar_none' is free/base
      AR_STANDARD:     48513353711828,
      AR_PREMIUM:      48513353744596,
      // Coatings
      BLUE_LIGHT:      48513353777364,
      POLARIZED:       48513353810132,
      // Finish upgrades
      FASHION_TINT:    48513353842900,
      SUN_TINT:        48513353875668,
      SLEEP_LENS:      48513353908436,
      FL41:            48513353941204,
      PHOTOCHROMIC:    48513353973972,
      TRANS_SIG:       48513354006740,
      TRANS_XT:        48513354039508,
      // Lens-type upgrades — single vision is free/base
      PROGRESSIVE:     48515568566484,
      BIFOCAL:         48515568599252,
      // Base/free variants (currently $0 — priced automatically if you raise them in Shopify)
      SV_DISTANCE:     48515576037588,
      SV_READING:      48515576070356,
      CR39:            48515576103124,
      AR_NONE:         48515576135892,
      CLEAR:           48515576168660,
      FRAME_ONLY:      48515576201428
    };

    // Build a properties object for a specific upgrade variant so the cart shows
    // meaningful details on each line (e.g. tint color, lens type)
    function getUpgradeVariantProperties(variantId, s) {
      const props = {};
      if (variantId === UPGRADE_VARIANTS.SV_DISTANCE) {
        props['Vision'] = 'Distance';
      } else if (variantId === UPGRADE_VARIANTS.SV_READING) {
        props['Vision'] = 'Reading';
      } else if (variantId === UPGRADE_VARIANTS.PROGRESSIVE) {
        props['Vision'] = 'Progressive (no-line bifocal)';
      } else if (variantId === UPGRADE_VARIANTS.BIFOCAL) {
        props['Vision'] = 'Bifocal (lined)';
      } else if (variantId === UPGRADE_VARIANTS.FRAME_ONLY) {
        props['Vision'] = 'Frame Only — No Rx Lenses';
      } else if (variantId === UPGRADE_VARIANTS.FASHION_TINT) {
        if (s.rx_fashion_tint) props['Color'] = humanize(s.rx_fashion_tint);
      } else if (variantId === UPGRADE_VARIANTS.SUN_TINT) {
        if (s.rx_sun_tint) props['Color'] = humanize(s.rx_sun_tint);
      } else if (variantId === UPGRADE_VARIANTS.POLARIZED) {
        if (s.rx_sun_tint) props['Base tint'] = humanize(s.rx_sun_tint);
      } else if (variantId === UPGRADE_VARIANTS.PHOTOCHROMIC) {
        if (s.rx_photochromic_color) props['Color'] = humanize(s.rx_photochromic_color);
      } else if (variantId === UPGRADE_VARIANTS.TRANS_SIG || variantId === UPGRADE_VARIANTS.TRANS_XT) {
        if (s.rx_transitions_color) props['Color'] = humanize(s.rx_transitions_color);
      }
      return props;
    }

    function getUpgradeVariantIds() {
      const s = state.selections;
      const ids = [];

      // Lens type — all four options mapped so any future price change flows through automatically
      if (s.rx_lens_type === 'sv_distance') { if (getVariantPriceCents(UPGRADE_VARIANTS.SV_DISTANCE) > 0) ids.push(UPGRADE_VARIANTS.SV_DISTANCE); }
      else if (s.rx_lens_type === 'sv_reading') { if (getVariantPriceCents(UPGRADE_VARIANTS.SV_READING) > 0) ids.push(UPGRADE_VARIANTS.SV_READING); }
      else if (s.rx_lens_type === 'progressive') ids.push(UPGRADE_VARIANTS.PROGRESSIVE);
      else if (s.rx_lens_type === 'bifocal') ids.push(UPGRADE_VARIANTS.BIFOCAL);
      else if (s.rx_lens_type === 'frame_only_alt') { if (getVariantPriceCents(UPGRADE_VARIANTS.FRAME_ONLY) > 0) ids.push(UPGRADE_VARIANTS.FRAME_ONLY); }

      // Material — CR-39 is base ($0 today, but wired so a future price change flows through)
      if (s.rx_material === 'mat_cr39') { if (getVariantPriceCents(UPGRADE_VARIANTS.CR39) > 0) ids.push(UPGRADE_VARIANTS.CR39); }
      else if (s.rx_material === 'mat_poly') ids.push(UPGRADE_VARIANTS.MAT_POLY);
      else if (s.rx_material === 'mat_hi167') ids.push(UPGRADE_VARIANTS.MAT_HI167);
      else if (s.rx_material === 'mat_hi174') ids.push(UPGRADE_VARIANTS.MAT_HI174);

      // Finish path — mutually exclusive
      if (s.rx_finish === 'finish_clear') {
        if (getVariantPriceCents(UPGRADE_VARIANTS.CLEAR) > 0) ids.push(UPGRADE_VARIANTS.CLEAR);
        if (s.rx_ar === 'ar_none') { if (getVariantPriceCents(UPGRADE_VARIANTS.AR_NONE) > 0) ids.push(UPGRADE_VARIANTS.AR_NONE); }
        else if (s.rx_ar === 'ar_standard') ids.push(UPGRADE_VARIANTS.AR_STANDARD);
        else if (s.rx_ar === 'ar_premium') ids.push(UPGRADE_VARIANTS.AR_PREMIUM);
      } else if (s.rx_finish === 'finish_fashion_tint') {
        ids.push(UPGRADE_VARIANTS.FASHION_TINT);
      } else if (s.rx_finish === 'finish_sun_tint') {
        ids.push(UPGRADE_VARIANTS.SUN_TINT);
        if (s.rx_polarized) ids.push(UPGRADE_VARIANTS.POLARIZED);
      } else if (s.rx_finish === 'finish_therapeutic') {
        if (s.rx_therapeutic_kind === 'sleep_lens') ids.push(UPGRADE_VARIANTS.SLEEP_LENS);
        else if (s.rx_therapeutic_kind === 'fl41') ids.push(UPGRADE_VARIANTS.FL41);
      } else if (s.rx_finish === 'finish_photochromic') {
        if (s.rx_pc_brand === 'photochromic') {
          ids.push(UPGRADE_VARIANTS.PHOTOCHROMIC);
        } else if (s.rx_pc_brand === 'transitions') {
          if (s.rx_transitions_type === 'xtractive') ids.push(UPGRADE_VARIANTS.TRANS_XT);
          else ids.push(UPGRADE_VARIANTS.TRANS_SIG);
        }
      }

      // Blue-light filter add-on — available on any finish (matches modal display)
      if (s.rx_coating_bluelight) {
        ids.push(UPGRADE_VARIANTS.BLUE_LIGHT);
      }

      return ids;
    }

    async function handleAddToCart() {
      if (!validateCurrentStep()) return;
      if (!validateMutualExclusivity()) return;

      const confirmValid = $('[name="rx_confirm_valid"]', builder);
      if (confirmValid && !confirmValid.checked) return fail('Please confirm your prescription is valid.');

      if (state.selections.rx_entry_method === 'manual') {
        const confirmAccurate = $('[name="rx_confirm_accurate"]', builder);
        if (confirmAccurate && !confirmAccurate.checked) return fail('Please confirm your Rx is accurate.');
      }

      const form = getProductForm();
      if (!form) return fail('Could not find product form. Please contact support.');

      // Get the frame variant ID from the product form
      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      const frameVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!frameVariantId) return fail('Could not identify the frame variant. Please refresh and try again.');

      // Disable the add-to-cart button to prevent double-submit
      const btn = $('[data-rx-add-to-cart]', builder);
      const btnOriginalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart...'; }

      try {
        // Generate a shared group ID so upgrades can be visually grouped under the frame
        const groupId = 'rx-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        const rxProps = buildLineItemProperties();
        rxProps['_RxGroup'] = groupId;

        // Build the items array: frame first (with full Rx properties), then upgrade variants
        // Each upgrade carries a compact reference back to the group so themes/apps can pair them
        const items = [
          { id: frameVariantId, quantity: 1, properties: rxProps }
        ];
        const upgradeIds = getUpgradeVariantIds();
        upgradeIds.forEach((upgradeId) => {
          const extraProps = getUpgradeVariantProperties(upgradeId, state.selections);
          items.push({
            id: upgradeId,
            quantity: 1,
            properties: Object.assign({
              _RxGroup: groupId,
              _ParentFrame: String(frameVariantId)
            }, extraProps)
          });
        });

        // If there's a prescription file, we still need to upload it. Shopify's
        // /cart/add.js accepts multipart form data with `properties[Rx File]`, but
        // NOT alongside `items[]`. So we split: file upload happens first as a
        // single-item POST on the frame, then upgrades are added separately.
        const fileInput = builder.querySelector('input[type="file"][name="rx_prescription_file"]');
        const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;

        if (hasFile) {
          // Step 1: add the frame with file via multipart
          const fd = new FormData();
          fd.append('id', frameVariantId);
          fd.append('quantity', 1);
          Object.entries(rxProps).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== '') {
              fd.append(`properties[${k}]`, v);
            }
          });
          fd.append('properties[Rx File]', fileInput.files[0], fileInput.files[0].name);
          const r1 = await fetch('/cart/add.js', { method: 'POST', body: fd });
          if (!r1.ok) throw new Error('Failed to add frame to cart (' + r1.status + ').');

          // Step 2: add upgrades as bulk items
          if (upgradeIds.length > 0) {
            const r2 = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items.slice(1) })
            });
            if (!r2.ok) throw new Error('Frame was added but failed to add upgrades (' + r2.status + '). Please contact support.');
          }
        } else {
          // Single bulk call: frame + all upgrades in one shot
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!r.ok) {
            const errText = await r.text().catch(() => '');
            throw new Error('Cart add failed (' + r.status + '). ' + errText);
          }
        }

        // Dispatch a Shopify-standard event so the theme's cart drawer can react.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('theme:cart:update'));

        // Redirect to /cart so the customer sees the full order
        window.location.href = '/cart';
      } catch (err) {
        if (btn) { btn.disabled = false; btn.textContent = btnOriginalText; }
        fail(err && err.message ? err.message : 'Could not add to cart. Please try again.');
      }
    }

    // ==========================================================================
    // WIRE UP
    // ==========================================================================

    // Build dynamic content first
    buildRxGrid();
    buildPrismGrid();
    populatePDDropdowns();
    buildTintViewer();

    builder.addEventListener('change', handleInputChange);
    builder.addEventListener('input', (e) => {
      if (['text', 'date', 'tel'].includes(e.target.type)) handleInputChange(e);
    });

    $('[data-rx-next]', builder).addEventListener('click', () => {
      if (validateCurrentStep()) nextStep();
    });
    $('[data-rx-back]', builder).addEventListener('click', prevStep);
    $('[data-rx-add-to-cart]', builder).addEventListener('click', handleAddToCart);

    initTabs();
    updatePrice();
    updateNavButtons();
    updateProgress();
  }
})();
